import { keyframes } from '@mui/system';

export const pulse = keyframes`
  25% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
`;
